import React from "react"

import { mapStatusToPillColorClass } from "../../utils"

import "../../style/status-pill.module.css"

interface Props {
  status: "Active" | "Stopped" | "Restarting"
}

const StatusPill = (props: Props) => {
  // State
  const [pillColor, setPillColor] = React.useState(mapStatusToPillColorClass(props.status))

  // Update pill color on status change
  React.useEffect(() => {
    const newPillColor = mapStatusToPillColorClass(props.status)
    setPillColor(newPillColor)
  }, [props.status])

  return (
    <div className={`status-pill ${pillColor}`}>
      {props.status}
    </div>
  )
}

export default StatusPill
